import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

const getDemand = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "estimations_demand_planning"),
  };

  return athenaClient(config);
};

export default getDemand;
